import { fontSizes } from '../../../../constants/constants';
import dynamicfunction from '../../../../utils/dynamicfunction';
import { ErrorText, RadioButton, RowView, Text } from '../index';

const PassiveNonUsEntity = ({
  getContent,
  values,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  touched,
  optionsYesOrNO,
  errors,
}) => {
  const { TextWeight } = dynamicfunction();

  return (
    <>
      <div className='pt-3 sm:pt-5'>
        <Text
          text={getContent('if_passive_non_us_entity')}
          size={fontSizes.h18}
          isTruncate={false}
          weight={TextWeight.medium}
          className='block'
          isRequired={true}
        />
      </div>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('are_you_passive_non_financial_non_us')}
            value={values?.passiveNonFinancialNonUsEntity}
            onChange={(e) => {
              setFieldValue('passiveNonFinancialNonUsEntity', e);
              setFieldTouched('passiveNonFinancialNonUsEntity', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.passiveNonFinancialNonUsEntity ? errors?.passiveNonFinancialNonUsEntity : '')}
          />
        </div>
      </RowView>
    </>
  );
};
export default PassiveNonUsEntity;
